import React from 'react';
import { useNavigate } from 'react-router';

const DrAeshaAreasOfFocus = () => {
  const navigate = useNavigate();
  const services = [
    {
      title: "Family Dentistry",
      description: "Comprehensive care for patients of all ages",
      icon: (
        <svg className="w-16 h-16 stroke-current" viewBox="0 0 24 24" fill="none" strokeWidth="1.5">
          <path d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0 0c4.97 0 9 2.239 9 5m-9-5c-4.97 0-9 2.239-9 5m9-5v5m9 0v3c0 .552-.448 1-1 1H7m-7-4v3c0 .552.448 1 1 1h6" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      title: "Dental Implant Surgery",
      description: "Permanent solutions for missing teeth",
      icon: (
        <svg className="w-16 h-16 stroke-current" viewBox="0 0 24 24" fill="none" strokeWidth="1.5">
          <path d="M12 4v16m0-16c1.5-1.5 3-2 5-2s4 1 4 3.5c0 3-3 6.5-9 14.5m0-16C10.5 2.5 9 2 7 2s-4 1-4 3.5c0 3 3 6.5 9 14.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      title: "Root Canal Therapy",
      description: "Preserving your natural teeth with precision care",
      icon: (
        <svg className="w-16 h-16 stroke-current" viewBox="0 0 24 24" fill="none" strokeWidth="1.5">
          <path d="M12 2c3 0 7 2 7 7 0 3-2 5-2 8 0 2.5-2 5-5 5s-5-2.5-5-5c0-3-2-5-2-8 0-5 4-7 7-7z" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    }
  ];

  return (
    <div className="mx-auto px-6 md:px-20 py-20 bg-gradient-to-br from-teal-50 to-green-50">
      {/* Section Title */}
      <div className="text-center mb-16">
        <h2 className="text-4xl font-serif text-teal-600 mb-4">
          Areas of Focus
        </h2>
        <div className="w-24 h-1 bg-lime-500 mx-auto"></div>
      </div>

      {/* Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {services.map((service, index) => (
          <div
            key={index}
            className="group bg-white rounded-lg shadow-lg p-8 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 border-t-4 border-transparent hover:border-t-4 hover:border-lime-500"
          >
            {/* Icon Container */}
            <div className="flex justify-center mb-6">
              <div className="text-teal-600 group-hover:text-teal-500 transition-colors duration-300">
                {service.icon}
              </div>
            </div>

            {/* Title */}
            <h3 className="text-xl font-serif text-teal-700 text-center group-hover:text-teal-600 mb-3 transition-colors duration-300">
              {service.title}
            </h3>
            
            {/* Description */}
            <p className="text-gray-600 text-center text-sm">
              {service.description}
            </p>
          </div>
        ))}
      </div>
      
      {/* Additional Services Button */}
      <div className="text-center mt-12">
        <button 
            onClick={() => navigate('/service')}
            className="cursor-pointer px-8 py-3 bg-teal-500 hover:bg-teal-600 text-white rounded-lg shadow transition-colors mx-auto">
          View All Services
        </button>
      </div>
    </div>
  );
};

export default DrAeshaAreasOfFocus;